import { Pipe, PipeTransform } from '@angular/core';
import { DeviceStaticDataService } from '@shared/services/device-static-data.service';

@Pipe({
  name: 'deviceStatus',
})
export class DeviceStatusPipe implements PipeTransform {
  constructor(private deviceStaticDataService: DeviceStaticDataService) {}

  transform(status: string): string {
    return this.deviceStaticDataService.statuses[status] || status;
  }
}
